import React from 'react';

import video from '../../img/videolaranja.svg';
import Modal from '../../components/modal.v2/Modal';
import CargaBox from './CargaBox';

export default class ItemExercicio extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      carga: props.data.carga
    };
    this.callVideoBox = this.callVideoBox.bind(this);
    this.openCarga = this.openCarga.bind(this);
    this.changeCarga = this.changeCarga.bind(this);
  }

  changeCarga(carga){
    this.setState({
      carga
    });
  }

  openCarga(e){
    e.preventDefault();
    const data = this.props.data;

    Modal.create({
      content: <CargaBox id={data.id} onChange={this.changeCarga} />,
      classes: "modal-carga-box"
    });
  }

  callVideoBox(e){
    e.preventDefault();
    this.setState({
      statusVideo: !this.state.statusVideo
    });
  }

  render(){
    const data = this.props.data;
    //autoplay=1&
    let videos = data.videos.map((value, i) =>
        <div href="#" key={i} className='video-ex'>
          <div>{value.nome}</div>
          <iframe
            className='vimeo-video'
            src={`https://player.vimeo.com/video/${value.video}?loop=1&autopause=0`}
            height="300"
            frameBorder="0"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            allowFullScreen="true">
          </iframe>
          { (value.observacoes) ? <div className="obs-video">{value.observacoes}</div> : null }
        </div>
      );

      const box = `${this.state.statusVideo ? 'ativo' : ''} box-detail-item-exercicio`;

    return(
      <div className="item-exercicio">
        <div className="box-exercicio">
          <span  className='video-name-ex'>{data.nome}</span>
          <div className="ex-right-box">
            <div className="wrapper-carga">
              <span>Carga</span>
              <div className="box-carga"><a href="#" className="bt-carga" onClick={this.openCarga}><span className="carga-value">{this.state.carga}</span></a></div>
            </div>
            <div className="bt-video-box"><a onClick={this.callVideoBox} href="#"><img src={video} /></a></div>
            <div className="clear"></div>
          </div>
        </div>
        <div className={box}>
          {videos}
          <div>{data.observacoes}</div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/classes/treino/ItemExercicio.js